import { gql } from 'apollo-boost';

const gymsQuery = gql`
  query statsGyms($inputFilter: StatsGymFilterInputType) {
    statsGyms(inputFilter: $inputFilter) {
      gymName
      gymId
      countMembers
      sumContributions
      countPaidMembers
      percent
    }
  }
`;

const sectionsQuery = gql`
  query statsSections($inputFilter: StatsSectionsFilterInputType) {
    statsSections(inputFilter: $inputFilter) {
      sectionName
      sectionId
      countMembers
      sumContributions
      countPaidMembers
      percent
    }
  }
`;

const STATS = {
  gymsQuery,
  sectionsQuery,
};

export default STATS;
